module.exports = __webpack_public_path__ + "58b5a46d3b462db87a1ba09e32f6bb7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/sm_image_1.jpg
// module id = 156
// module chunks = 0